import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { createGoodsReceipt } from './api';
import type { NewGoodsReceiptInput } from './types';

/**
 * Invalidates three query families: the GRN list itself, inventory (a GRN is
 * the only place stock quantity increases — see pharmacy-procurement.js's
 * header comment), and purchase orders (a GRN referencing a po_id flips that
 * PO to 'received' server-side).
 */
export function useCreateGoodsReceipt() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: NewGoodsReceiptInput) => createGoodsReceipt(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.pharmacy.goodsReceipts() });
      queryClient.invalidateQueries({ queryKey: keys.pharmacy.inventory() });
      queryClient.invalidateQueries({ queryKey: keys.procurement.purchaseOrders() });
    },
  });
}
